


import React from 'react';
import { Link } from 'react-router-dom';
import '../stylesh/Sec3Home.css';
// Ensure these paths match your project exactly
import EMSHome from '../../../assets/home/EMS-home.svg';
import DaasHome from '../../../assets/home/EndPoint/DaasHome.png';
import AppModernizationHome from '../../../assets/home/Application-Modernization-home.svg';
import IRCHome from '../../../assets/home/IRC-home.svg';

const Sec3Home = () => {
  return (
    <section className="sec3-home">
      <div className="sec3-home-container">
        <h2 className="sec3-main-title">What We Do</h2>
        <div className="sec3-rows-wrapper">

          {/* Row 2: Desktop as a Service */}
          <div className="sec3-row">
            <div className="sec3-text-col">
              <div className="sec3-text-inner">
                <h3 className="sec3-title">Desktop as a Service (DaaS)</h3>
                <p className="sec3-desc">
                  Synectiks DaaS delivers secure, cloud-hosted virtual desktops and applications that let users access their workspace from any device with enterprise-grade security. We use modern virtualization technology to ensure scalability, performance, and uptime while supporting both Windows and Linux environments. The cost-effective, anywhere access service includes strong access controls, authentication, and compliance-ready protections to keep corporate data secure.
                </p>
                {/* <a href="/services/daas" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </a> */}
                <Link to="/services/daas" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </Link>
              </div>
            </div>
            <div className="sec3-img-col">
              <img src={DaasHome} alt="Desktop as a Service (DaaS)" />
            </div>
          </div>

          {/* Row 1: Endpoint Management */}
          <div className="sec3-row">
            <div className="sec3-text-col">
              <div className="sec3-text-inner">
                <h3 className="sec3-title">Endpoint Management & Security</h3>
                <p className="sec3-desc">
                  Strengthen your security posture with unified endpoint protection, continuous monitoring, and automated updates. Synectiks ensures every device is safeguarded against modern threats while maintaining operational continuity. With integrated Microsoft 365 services, your teams stay productive and secure from anywhere.
                </p>
                {/* <a href="/services/endpoint" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </a> */}
                <Link to="/services/endpoint" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </Link>
              </div>
            </div>
            <div className="sec3-img-col">
              <img src={EMSHome} alt="Endpoint Management & Security" />
            </div>
          </div>


          {/* Row 3: Infrastructure Resilience */}
          <div className="sec3-row">
            <div className="sec3-text-col">
              <div className="sec3-text-inner">
                <h3 className="sec3-title">Infrastructure Resilience & Business Continuity</h3>
                <p className="sec3-desc">
                  Build a foundation engineered for performance and protection. Synectiks delivers modern, scalable infrastructure across hybrid and public clouds, complete with container-ready environments, and optimized workload management. With integrated backup and disaster recovery, your data stays safe and your operations stay uninterrupted.
                </p>
                {/* <p className="sec3-desc"></p> */}
                {/* <a href="/solutions/cloud-adoption" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </a> */}
                <Link to="/services/infrastructure" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </Link>
              </div>
            </div>
            <div className="sec3-img-col">
              <img src={IRCHome} alt="Infrastructure Resilience & Cloud" />
            </div>
          </div>

          {/* Row 4: Application Modernization */}
          <div className="sec3-row">
            <div className="sec3-text-col">
              <div className="sec3-text-inner">
                <h3 className="sec3-title">Application Modernization</h3>
                <p className="sec3-desc">
                  Elevate your business with modern applications and seamless cloud adoption. Synectiks transforms legacy systems into scalable, cloud-ready solutions while delivering secure, efficient migration across platforms.
                </p>
                {/* <a href="/solutions/application-development" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </a> */}
                <Link to="/solutions/application-development" className="sec3-link">
                  Learn more <span className="arrow">→</span>
                </Link>
              </div>
            </div>
            <div className="sec3-img-col">
              <img src={AppModernizationHome} alt="Application Modernization" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Sec3Home;
















// import React from 'react';
// import { Link } from 'react-router-dom';
// import '../stylesh/Sec3Home.css';

// // Asset Imports
// import EMSHome from '../../../assets/home/EMS-home.svg';
// import DaasHome from '../../../assets/home/EndPoint/DaasHome.png';
// import AppModernizationHome from '../../../assets/home/Application-Modernization-home.svg';
// import IRCHome from '../../../assets/home/IRC-home.svg';

// const Sec3Home = () => {
//   return (
//     <section className="sec3-home">
//       <div className="sec3-home-container">
//         <h2 className="sec3-main-title">What We Do</h2>
//         <div className="sec3-rows-wrapper">

//           {/* Row 1: Desktop as a Service */}
//           <div className="sec3-row">
//             <div className="sec3-text-col">
//               <div className="sec3-text-inner">
//                 <h3 className="sec3-title">Desktop as a Service (DaaS)</h3>
//                 <p className="sec3-desc">
//                   Synectiks DaaS delivers secure, cloud-hosted virtual desktops and applications that let users access their workspace from any device with enterprise-grade security. We use modern virtualization technology to ensure scalability, performance, and uptime while supporting both Windows and Linux environments.
//                 </p>
//                 <Link to="/services/daas" className="sec3-link">
//                   Learn more <span className="arrow">→</span>
//                 </Link>
//               </div>
//             </div>
//             <div className="sec3-img-col">
//               <img src={DaasHome} alt="Desktop as a Service (DaaS)" />
//             </div>
//           </div>

//           {/* Row 2: Endpoint Management */}
//           <div className="sec3-row">
//             <div className="sec3-text-col">
//               <div className="sec3-text-inner">
//                 <h3 className="sec3-title">Endpoint Management & Security</h3>
//                 <p className="sec3-desc">
//                   Strengthen your security posture with unified endpoint protection, continuous monitoring, and automated updates. Synectiks ensures every device is safeguarded against modern threats while maintaining operational continuity.
//                 </p>
//                 <Link to="/services/endpoint" className="sec3-link">
//                   Learn more <span className="arrow">→</span>
//                 </Link>
//               </div>
//             </div>
//             <div className="sec3-img-col">
//               <img src={EMSHome} alt="Endpoint Management & Security" />
//             </div>
//           </div>

//           {/* Row 3: Infrastructure Resilience */}
//           <div className="sec3-row">
//             <div className="sec3-text-col">
//               <div className="sec3-text-inner">
//                 <h3 className="sec3-title">Infrastructure Resilience & Business Continuity</h3>
//                 <p className="sec3-desc">
//                   Build a foundation engineered for performance and protection. Synectiks delivers modern, scalable infrastructure across hybrid and public clouds, complete with container-ready environments, and optimized workload management.
//                 </p>
//                 <Link to="/solutions/cloud-adoption" className="sec3-link">
//                   Learn more <span className="arrow">→</span>
//                 </Link>
//               </div>
//             </div>
//             <div className="sec3-img-col">
//               <img src={IRCHome} alt="Infrastructure Resilience & Cloud" />
//             </div>
//           </div>

//           {/* Row 4: Application Modernization */}
//           <div className="sec3-row">
//             <div className="sec3-text-col">
//               <div className="sec3-text-inner">
//                 <h3 className="sec3-title">Application Modernization</h3>
//                 <p className="sec3-desc">
//                   Elevate your business with modern applications and seamless cloud adoption. Synectiks transforms legacy systems into scalable, cloud-ready solutions while delivering secure, efficient migration across platforms.
//                 </p>
//                 <Link to="/solutions/application-development" className="sec3-link">
//                   Learn more <span className="arrow">→</span>
//                 </Link>
//               </div>
//             </div>
//             <div className="sec3-img-col">
//               <img src={AppModernizationHome} alt="Application Modernization" />
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default Sec3Home;